import { Injectable } from '@angular/core';
import { ProxyService } from '@caslink/common-client/ng-app/proxy/ProxyService';
import { IRtuCurrentInfoViewModel } from '../shared/models/models';

@Injectable({
    providedIn: 'root'
})
export class RtuCurrentInfoService {
    public static $name = 'rtuCurrentInfoService';

    constructor(
        private proxyService: ProxyService
    ) {
    }

    public getRTUCurrentInfo(
        locationId: number,
        locationAreaId: number,
        hardwareItemId: number)
    : angular.IPromise<IRtuCurrentInfoViewModel> {
        return this.proxyService.request({
            endPoint: 'hardware',
            route: 'getRtuCurrentInfo',
            routeParams: {
                hardwareItemId: hardwareItemId,
                locationId: locationId,
                locationAreaId: locationAreaId
            }
        }).as<IRtuCurrentInfoViewModel>();
    }
}
